import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetMusicByCategoryParamsSchema = ActionCommonParamsSchema.extend({
    category_id: z.string(),
    type: z.string(),
    count: z.number().optional(),
});

export type DouyinGetMusicByCategoryParams = z.infer<typeof DouyinGetMusicByCategoryParamsSchema>;
